var chunkMapping = {
	"869": [
		40869
	],
	"1369": [
		61369
	],
	"2812": [
		82812
	],
	"3030": [
		73030
	],
	"3130": [
		83130
	],
	"4454": [
		54454
	],
	"4770": [
		34770
	],
	"4945": [
		14945
	],
	"5075": [
		15075
	],
	"5297": [
		25297
	],
	"5620": [
		85620
	],
	"5833": [
		35833
	],
	"5871": [
		95871
	],
	"6805": [
		6805
	],
	"6928": [
		6928
	],
	"6972": [
		26972
	],
	"7691": [
		17691
	],
	"7748": [
		77748
	],
	"7852": [
		37852
	],
	"8530": [
		88530
	],
	"9167": [
		69167
	],
	"9749": [
		49749
	],
	"9967": [
		69967
	]
};
var idToExternalAndNameMapping = {
	"6805": [
		"default",
		"./TradeCumulativeChart",
		91046
	],
	"6928": [
		"default",
		"./PMFIncome",
		91046
	],
	"14945": [
		"default",
		"./PMFAssetAnalysis",
		91046
	],
	"15075": [
		"default",
		"./PMFPerformanceChart",
		91046
	],
	"17691": [
		"default",
		"./AssetAnalysisOverview",
		91046
	],
	"25297": [
		"default",
		"./PortfolioOverview",
		91046
	],
	"26972": [
		"default",
		"./Fundamentals",
		91046
	],
	"34770": [
		"default",
		"./PMFSensitivity",
		91046
	],
	"35833": [
		"default",
		"./app",
		91046
	],
	"37852": [
		"default",
		"./PositionVerticalTab",
		91046
	],
	"40869": [
		"default",
		"./MetricsTable",
		91046
	],
	"49749": [
		"default",
		"./TradeRealisedUnrealisedChart",
		91046
	],
	"54454": [
		"default",
		"./TradeBuySellChart",
		91046
	],
	"61369": [
		"default",
		"./TradePositionHistory",
		91046
	],
	"69167": [
		"default",
		"./RelationShipManager",
		91046
	],
	"69967": [
		"default",
		"./AssetAnalysisNews",
		91046
	],
	"73030": [
		"default",
		"./TopPositionsGain",
		91046
	],
	"77748": [
		"default",
		"./HoldingsTable",
		91046
	],
	"82812": [
		"default",
		"./TransactionTable",
		91046
	],
	"83130": [
		"default",
		"./AssetAnalysisInsight",
		91046
	],
	"85620": [
		"default",
		"./PMFRiskStressTest",
		91046
	],
	"88530": [
		"default",
		"./PMFMonthlyPerformance",
		91046
	],
	"95871": [
		"default",
		"./Attribution",
		91046
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}